import React from "react";
import { Modal, Box } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import RegisterForm from "./RegisterForm";
import "../../styles/LoginModal.scss";
import { IoCloseCircle } from "react-icons/io5";

function RegisterModal({ open, onClose, onOpenLogin }) {
  return (
    <Modal 
      open={open} 
      onClose={onClose}
      sx={{ zIndex: 1000 }}>
      <Box
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '80%', md: 604 },
            maxWidth: '100%',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: '10px',
            maxHeight: '90%',
            overflowY: 'auto'
        }}>
        <IconButton className="modalCloseButton" onClick={onClose}>
          <IoCloseCircle />
        </IconButton>
        <div id="signin-modal-title">Registrarse</div>
        <hr></hr>
        <RegisterForm onOpenLogin={onOpenLogin}  onCloseRegister={onClose} source="modal"/>
      </Box>
    </Modal>
  );
}

export default RegisterModal;
